// Eleanor & Marcus — Wedding scrapbook (Blush #F8E6DC · Sage #A8B89A · Gold #B89C5C)
export const META = { brand: 'Eleanor & Marcus', date: 'Saturday, the 13th of June, 2026', loc: 'Casa di Bagni · Lago di Como, Italia' };
export const ROUTES = [
  { id: 'home', label: 'Cover' },
  { id: 'story', label: 'Our story' },
  { id: 'days', label: 'The four days' },
  { id: 'rsvp', label: 'RSVP' },
];

export const DAYS = [
  { d: 'Thu', date: 'June 11', t: 'Welcome night', loc: 'Hotel Belvedere · 19:00', desc: 'A relaxed pizzeria dinner on the lake. No dress code; please bring a sweater.' },
  { d: 'Fri', date: 'June 12', t: 'The villa lunch', loc: 'Villa Pliniana · 13:00', desc: 'A long lunch in the lemon garden. Boats arranged from Bellagio at 11:30.' },
  { d: 'Sat', date: 'June 13', t: 'The wedding', loc: 'Casa di Bagni · 16:30', desc: 'Ceremony on the lower terrace at 16:30, reception at 19:00, dancing until very late.' },
  { d: 'Sun', date: 'June 14', t: 'Lake breakfast', loc: 'Casa di Bagni · 11:00', desc: 'Breakfast and a slow goodbye. Coffees on the dock until you have to leave.' },
];

export const STORY = [
  { yr: '2018', t: 'A queue at a coffee shop, Rome', d: 'Eleanor was reading Tolstoy. Marcus tapped her shoulder to say his oat milk had spilled.' },
  { yr: '2020', t: 'Lockdown, Brooklyn', d: 'They moved in on the third date because there was nowhere else to go.' },
  { yr: '2023', t: 'A small flat in Lisbon', d: 'A summer they took as a sabbatical, walking through the Alfama and learning to cook.' },
  { yr: '2025', t: 'A morning at the lake', d: 'Marcus asked, on the dock at Casa di Bagni, with Eleanor’s grandmother’s ring.' },
];
